export const InitialValuesIngDPGF = {
	title: '',
	origin: '',
	unit: '',
	quantity: '',
	total: '',
}
